import React from 'react';
import styled from 'styled-components';

const LoadingContainer = styled.div<{ $size?: 'small' | 'normal'; $absolute?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${({ $size }) => $size === 'small' ? '100px' : '100vh'};
  background: transparent;
  ${({ $absolute }) => $absolute && `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
  `}
`;

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${({ theme }) => theme.colors.border};
  border-top: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export interface LoadingIndicatorProps {
  show?: boolean;
  size?: 'small' | 'normal';
  absolute?: boolean;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ show, size = 'normal', absolute = false }) => {
  if (!show) return null;
  
  return (
    <LoadingContainer $size={size} $absolute={absolute}>
      <LoadingSpinner />
    </LoadingContainer>
  );
};

export default LoadingIndicator;